import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke={color} strokeWidth={2}>
      <path d="M21 10c-2.362-2.482-5.524-4-9-4s-6.638 1.518-9 4m3 3c1.409-1.829 3.573-3 6-3s4.592 1.171 6 3" />
      <circle cx={12} cy={16} r={2} />
    </g>
  </svg>
);
